import { render, staticRenderFns } from "./carNum.vue?vue&type=template&id=37c1042a&scoped=true&"
import script from "./carNum.vue?vue&type=script&lang=js&"
export * from "./carNum.vue?vue&type=script&lang=js&"
import style0 from "./carNum.vue?vue&type=style&index=0&lang=css&"
import style1 from "./carNum.vue?vue&type=style&index=1&id=37c1042a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c1042a",
  null
  
)

export default component.exports